import { navigate, RouteComponentProps, useLocation } from '@reach/router';
import React, { useEffect } from 'react';
import {
  OneTimePayConfigData,
  OneTimePayConfirmationResponse,
} from '../../../../components/payment-form/oneTimePayment.types';
import ROUTES from '../../../../routes';
import PaymentConfirmationForm from '../../../../components/payment-form/payment-confirmation-form';
import { Grid } from '@material-ui/core';
import theme from '../../../../themes/theme';
import { getInvoiceUrl } from '../../../../components/invoice-payment-portal/utils/navigation.util';

const InvoicePaymentConfirmation = (_: { path?: string }) => {
  type LocationState = {
    oneTimePayConfirmationData?: OneTimePayConfirmationResponse;
    needsCacheReset?: boolean;
    oneTimePayConfig: OneTimePayConfigData;
    paymentMethodCapLimit: number;
    invoiceId: string;
    
  };
  const PRINT_CONTAINER_ID = 'one-time-print-receipt';

  const location = useLocation();
  const state = (location.state || {}) as LocationState;
  useEffect(() => {
    if (!state.oneTimePayConfirmationData) {
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      navigate(ROUTES.INVOICE_PAYMENT_PORTAL_INVOICE_PAYMENT);
    }
  }, [state.oneTimePayConfirmationData]);

  if (!state.oneTimePayConfirmationData) {
    return null;
  }

  return (
    <Grid
      container
      css={{
        display: 'flex',
        justifyContent: 'center',
        marginTop: theme.spacing(7),
        marginBottom: theme.spacing(7),
      }}
      id={PRINT_CONTAINER_ID}
    >
      <Grid item xs={10}>
        <PaymentConfirmationForm
          oneTimePayConfirmationData={state.oneTimePayConfirmationData}
          oneTimePayConfig={state.oneTimePayConfig}
          paymentMethodCapLimit={state.paymentMethodCapLimit}
          printContainerId={PRINT_CONTAINER_ID}
          redirectionURL={getInvoiceUrl(ROUTES.INVOICE_PAYMENT_PORTAL_INVOICE_PAYMENT_INFO,state.invoiceId)}
          doneUrl={ROUTES.INVOICE_PAYMENT_PORTAL_INVOICE_LIST}
          invoiceId={state.invoiceId}
        />
      </Grid>
    </Grid>
  );
};
export default InvoicePaymentConfirmation;
